import { render, staticRenderFns } from "./bedType.vue?vue&type=template&id=458486cc&scoped=true&"
import script from "./bedType.vue?vue&type=script&lang=js&"
export * from "./bedType.vue?vue&type=script&lang=js&"
import style0 from "./bedType.vue?vue&type=style&index=0&id=458486cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458486cc",
  null
  
)

export default component.exports